<template>
  <div class="page-content"  id="MonitorDetails">
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newProductPandect'}">监控产品</el-breadcrumb-item>
      <el-breadcrumb-item>监控详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <!-- 计划信息 -->
      <el-col :span="24" style="margin-bottom: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          计划信息
        </div>
      </el-col>
      <el-col :span="24">
        <el-card>
          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                计划名称：
              </span>
              <span>
                {{hcmNewMonitorProduct.planname}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                监控平台：
              </span>
              <span v-for=" item in platformArr">
                {{item | platformChinese}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tenSize">
              <span class="fontColor">
                产品数：
              </span>
              <span style="margin-right: 40px;">
                {{productlist.length}}
              </span>
              <el-popover
                placement="start"
                width="360"
                trigger="hover">
                <div style="max-height: 320px;overflow-y: auto">
                  <div v-for="item in productlist" style="margin: 8px 0;">
                    {{item.product}}
                  </div>
                </div>
                <el-button slot="reference" type="text">详情</el-button>
              </el-popover>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                监控时间：
              </span>
              <span>
                {{hcmNewMonitorProduct.plathour}}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                计划状态：
              </span>
              <span v-if="hcmNewMonitorProduct.status == 1">
                开启
              </span>
              <span v-else>
                关闭
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="twoSize">
              <span class="fontColor">
                通知人：
              </span>
              <span v-if="hcmNewMonitorProduct.noticeusername">
                {{hcmNewMonitorProduct.noticeusername}}
              </span>
              <span v-else>
                --
              </span>
            </div>
          </el-col>
        </el-card>
      </el-col>
      <!-- 监控数据概览 -->
      <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;float: left;">
          <div class="iconDiv">
            .
          </div>
          监控数据概览
        </div>
        <div style="float: right;">
          <span class="demonstration">监控时间：</span>
          <el-date-picker
            v-model="valuedata"
            type="date"
            placeholder="请选择选择"
            size="mini"
            @change="valueDataChange(1)">
          </el-date-picker>
          <el-select v-model="valueTime" placeholder="请选择" size="mini" @change="valueDataChange(2)">
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="24">
        <el-card style="padding: 0 20px 20px 20px;">
          <el-col :span="6">
            <div>
              <div style="color: #0000006d;">
                监控产品数
              </div>
              <div style="font-size: 24px;margin-top: 10px;">
                {{productNum}}
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <div style="color: #0000006d;">
                监控链接数量
              </div>
              <div style="font-size: 24px;margin-top: 10px;">
                {{itemlinkNum}}
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <div style="color: #0000006d;">
                正常链接数量
              </div>
              <div style="margin-top: 10px;width: 100%;">
                <div style="width: 50%;float: left;font-size: 24px;">
                  {{notlowpriceLink}}
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-if="pricePercentage">
                  {{pricePercentage.toFixed(2)}}%
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-else>
                  0.00%
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <div style="color: #0000006d;">
                违规链接数量
              </div>
              <div style="margin-top: 10px;width: 100%;">
                <div style="width: 50%;float: left;font-size: 24px;">
                  {{lowpriceLink}}
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-if="lowpricePercentage">
                  {{lowpricePercentage.toFixed(2)}}%
                </div>
                <div style="width: 50%;float: right;font-size: 16px;margin-top: 10px;" v-else>
                  0.00%
                </div>
              </div>
            </div>
          </el-col>
        </el-card>
      </el-col>
      <!-- 各平台监控链接链接情况 -->
      <el-col :span="8" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;float: left;">
          <div class="iconDiv">
            .
          </div>
          各平台监控链接链接情况
        </div>
        <div style="float: right;padding-right: 20px;font-size: 16px;cursor: pointer;">
          <i class="el-icon-document" @click="getLinkNumByPlatform"></i>
          <i class="el-icon-download" style="padding-left: 20px;" @click="downloadLinkNumByPlatform"></i>
        </div>
      </el-col>
      <!-- 产品违规链接数量排名情况 -->
      <el-col :span="16" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;float: left;">
          <div class="iconDiv">
            .
          </div>
          产品违规链接数量排名情况
        </div>
        <div style="float: right;padding-right: 20px;font-size: 16px;cursor: pointer;">
          <i class="el-icon-document" @click="getLinkNumByProduct"></i>
          <i class="el-icon-download" style="padding-left: 20px;" @click="downloadLinkNumByProduct"></i>
        </div>
      </el-col>
      <el-col :span="8">
        <el-card style="margin-right: 20px;" v-loading="MonitorDetailsChartLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <div id="MonitorDetailsChart" :style="{width: '100%', height: '292px'}"></div>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card style="height: 332px;overflow: auto;">
          <el-table
          height="292px"
             :data="productMap"
             style="width: 100%"
             v-loading="productMapLoading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading">
               <el-table-column
               label="排名"
               type="index"
               min-width="10%">
             </el-table-column>
             <el-table-column
               prop="productname"
               label="产品"
               min-width="70%">
             </el-table-column>
             <el-table-column
               prop="lowpriceNum"
               label="违规链接数"
               min-width="20%">
             </el-table-column>
           </el-table>
        </el-card>
      </el-col>
      <!-- 监控结果详情 -->
      <el-col :span="24" style="margin-bottom: 20px;margin-top: 20px;">
        <div style="font-size: 16px;color: #333333;display: flex;">
          <div class="iconDiv">
            .
          </div>
          监控结果详情
        </div>
      </el-col>
    </el-row>
    <MonitorChildrenTable :paramsTime="childmonitortime" :paramsId='this.$route.query.id' ref="childrenTable"/>
  </div>
  <el-dialog title="数据详情" :visible.sync="byPlat" width="960px">
    <el-button @click="downloadLinkNumByPlatform" :loading="platformLoading" size="mini" style="margin-bottom: 8px;margin-top: 8px;margin-left: 4px;">下载数据</el-button>
    <div style="height: 647px;overflow: auto;">
      <el-table :data="byPlatData" style="margin-bottom: 60px;padding-left: 4px;padding-right: 4px;">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="platform" label="平台"></el-table-column>
        <el-table-column property="sumNum" label="总链接数"></el-table-column>
        <el-table-column property="notlowprice" label="价格正常"></el-table-column>
        <el-table-column property="islowprice" label="违规"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
  <el-dialog title="数据详情" :visible.sync="byProduct" width="960px">
    <el-button @click="downloadLinkNumByProduct" :loading="byProductLoading" size="mini" style="margin-bottom: 8px;margin-top: 8px;margin-left: 4px;">下载数据</el-button>
    <div style="height: 647px;overflow: auto;">
      <el-table :data="byProductData" style="margin-bottom: 60px;padding-left: 4px;padding-right: 4px;">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="productname" label="产品信息"></el-table-column>
        <el-table-column property="lowpriceNum" label="违规链接数"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</div>

</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import MonitorChildrenTable from "./MonitorChildrenTable";

  export default {
    data() {
      return {
        MonitorDetailsChartLoading: false,
        productMapLoading: false,
        pricePercentage: '',
        lowpricePercentage: '',
        timeOptions: [],
        valuedata: '',
        valueTime: '',
        productMap: [],
        MonitorDaya: [],
        MonitorListByPlatform: [],
        platformArr: [],
        productlist: [],
        hcmNewMonitorProduct: [],
        lowpriceLink: '',
        notlowpriceLink: '',
        monitortime: '',
        childmonitortime: '',
        productNum: '',
        itemlinkNum: '',
        byPlat: false,
        byProduct: false,
        byPlatData: [],
        byProductData: [],
        platformLoading: false,
        byProductLoading: false,
      }
    },
    mounted() {
      this.getProductMonitorDetail()
    },
    methods: {
      getLinkNumByProduct() {
        let params={
          planid: this.$route.query.id,
          monitortime: this.childmonitortime
        }
        fetch({
          url: "hcm/hcmProductMonitor/getLinkNumByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.byProductData = data
            this.compare(this.byProductData);
            console.log(this.byProductData)
            this.byProduct = true
          }
        }).catch(err => {

        })
      },
      //数组排序
      compare(arr) {
        var max;
        for(var i=0; i<arr.length; i++){
          for(var j=i; j<arr.length; j++){
            if(arr[i].lowpriceNum<arr[j].lowpriceNum){
              max=arr[j];
              arr[j]=arr[i];
              arr[i]=max;
            }
          }
        }
        return arr;
      },
      getLinkNumByPlatform() {
        let params={
          planid: this.$route.query.id,
          monitortime: this.childmonitortime
        }
        fetch({
          url: "hcm/hcmProductMonitor/getLinkNumByPlatform",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.byPlatData = data
            this.byPlat = true
          }
        }).catch(err => {

        })
      },
      // 下载
      downloadLinkNumByPlatform() {
        this.platformLoading = true
        let params = {
          planid: this.$route.query.id,
        };
        if (this.childmonitortime.length == 19) {
          params.monitortime = this.childmonitortime
        } else {
          params.monitortime = this.childmonitortime + ':00'
        }
        fetch({
          url: "hcm/hcmProductMonitor/downloadLinkNumByPlatform",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "各平台监控链接链接.xlsx");
          document.body.appendChild(link);
          link.click();
          this.platformLoading = false
        });
      },
      // 下载
      downloadLinkNumByProduct() {
        this.byProductLoading = true
        let params = {
          planid: this.$route.query.id,
        };
        if (this.childmonitortime.length == 19) {
          params.monitortime = this.childmonitortime
        } else {
          params.monitortime = this.childmonitortime + ':00'
        }
        fetch({
          url: "hcm/hcmProductMonitor/downloadLinkNumByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "产品违规链接数量排名.xlsx");
          document.body.appendChild(link);
          link.click();
          this.byProductLoading = false
        });
      },
      // 时间赋值
      valueDataChange(e) {
        if (e == 1) {
          this.monitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0]
          this.childmonitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0]
          this.valueTime = ''
          this.getHourByDate(this.monitortime)
        } else {
          this.monitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0] + ' ' + this.valueTime
          this.childmonitortime = this.$options.filters['fullTime'] (this.valuedata).split(' ')[0] + ' ' + this.valueTime
          this.$refs.childrenTable.pageData(this.monitortime);
          this.getProductMonitorDetail()
        }
      },
      // 数据源
      getProductMonitorDetail() {
        this.MonitorDetailsChartLoading = true
        this.productMapLoading = true
        let params={
          planid: this.$route.query.id,
        }
        if (this.monitortime) {
          params.monitortime = this.monitortime + ':00'
        } else {
          params.monitortime = ''
        }
        fetch({
          url: "hcm/hcmProductMonitor/getProductMonitorDetail",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.MonitorDetailsChartLoading = false
            this.productMapLoading = false
            console.log(data)
            this.$refs.childrenTable.pageData(data.monitortime);
            this.MonitorDaya = data.MonitorPage
            this.lowpriceLink = data.lowpriceLink
            this.notlowpriceLink = data.notlowpriceLink
            this.productNum = data.productNum
            this.itemlinkNum = data.itemlinkNum
            this.hcmNewMonitorProduct = data.hcmNewMonitorProduct
            if (data.hcmNewMonitorProduct && data.hcmNewMonitorProduct.platform) {
              this.platformArr = data.hcmNewMonitorProduct.platform.split(',')
            }

            this.productlist =  data.productlist
            this.MonitorListByPlatform =  data.MonitorListByPlatform

            this.productMap = data.lowpriceProductList
            this.compare(this.productMap);
            // 时间
            this.valuedata = data.monitortime.split(' ')[0]
            this.valueTime = data.monitortime.split(' ')[1].substring(0,5)
            this.childmonitortime = data.monitortime
            let num = parseInt(data.notlowpriceLink) + parseInt(data.lowpriceLink)
            this.pricePercentage = parseInt(data.notlowpriceLink) / parseInt(num) * 100

            let num2 = parseInt(data.notlowpriceLink) + parseInt(data.lowpriceLink)
            this.lowpricePercentage = parseInt(data.lowpriceLink) / parseInt(num) * 100
            this.drawLine(this.MonitorListByPlatform)
            if (data.monitortime) {
              this.getHourByDate(data.monitortime)
            }
          }
        }).catch(err => {

        })
      },
      // 柱状图
      drawLine(data) {
        let Xdata = []
        let seriesData = []
        let priceData = []
        if (data.length > 0) {
          for (let a in data) {
            if (data[a].platform) {
              Xdata.push(this.$options.filters['platformChinese'] (data[a].platform))
              seriesData.push(data[a].notlowprice)
              priceData.push(data[a].islowprice)
            }
          }
        }
        // 基于准备好的dom，初始化echarts实例
        let myChartDrawer = this.$echarts.init(document.getElementById('MonitorDetailsChart'))
          // 绘制条形图
          var option = {
            color: ['#975fe4','#3aa0ff'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            legend: {
              data: ['价格正常', '违规'],
              top: 30
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            // X轴
            xAxis: {
              type: 'category',
              data: Xdata
            },
            // Y轴
            yAxis: {
              type: "value"
            },
            // 数据
            series: [
              {
                 name: '价格正常',
                 type: 'bar',
                 data: seriesData,
                 barWidth: 20,
                 stack: Xdata,
              },{
                 name: '违规',
                 type: 'bar',
                 data: priceData,
                 barWidth: 20,
                 stack: Xdata,
              }

            ]
          };
          myChartDrawer.setOption(option);
      },
      // 获取时间
      getHourByDate(time) {
        let params={
          planid: this.$route.query.id,
          monitortime: time.split(' ')[0]
        }
        fetch({
          url: "hcm/hcmProductMonitor/getHourByDate",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            console.log(data)
            this.timeOptions = data
          }
        }).catch(err => {

        })
      },
    },
    components: {
      pagination,MonitorChildrenTable
    }
  }
</script>
<style lang="scss">
  #MonitorDetails{
    .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
      -webkit-box-shadow: none;
      box-shadow: none;
    }
    .el-table__empty-text {
      padding-top: 100px;
      background: url("../../../assets/img/other/nodata.svg") no-repeat;
      background-position: center 66px;
    }
    .el-table th {
      background-color: #f2f6fe !important;
      color: #4a4b4c;
    }
    .page {
      padding: 20px;
      margin: 10px 0px 0px 0px;
      background-color: white;
    }

    .el-button--TheCustom {
      color: #666;
      border-color: #D9D9D9;
      background-color: #fff;
    }
    .el-button--TheCustom:hover  {
      color: #666;
      border-color: #ded2b8;
      background-color: #faf9f5;
    }
    .iconDiv {
      width: 5px;
      background-color: #333333;
      margin-right: 10px;
      height: 21px;
      margin-top: 4px;
    }
    .fontColor {
      color: #000000a5;
    }
    .tenSize {
      height: 22px;
      margin-bottom: 10px;
    }
    .twoSize {
      height: 22px;
      margin-bottom: 20px;
    }

    #dialog {
      .el-button--primary {
        color: #FFF;
        background-color: #bda571;
        border-color: #bda571;
      }
      .el-button--primary:hover {
        color: #FFF;
        background-color: #c0ae8a;
        border-color: #c0ae8a;
      }
    }
  }
</style>
